import { Action, Reducer } from 'redux';
import { UserState, UserTypes, UserActionTypes } from './userTypes';
import { isNullUndefined } from '@/main/services/utils';

export const INITIAL_STATE: UserState = {
  currentUser: null,
  userPreference: {
    preferences: {
      guid: null,
      isViewCard: true
    },
    errorMessages: null,
    isError: false,
    isLoading: false
  },
  numberOfDaysToPasswordExpires: null,
  openModalUserChangePasswordAlert: false
};

const userReducer: Reducer<UserState> = (
  state: UserState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as UserActionTypes;
  switch (actionTypes.type) {
    case UserTypes.USER_SET_CURRENT:
      return {
        ...state,
        currentUser: actionTypes.payload
      };
    case UserTypes.GET_USER_PREFERENCES:
      return {
        ...state,
        userPreference: {
          ...state.userPreference,
          isLoading: true
        }
      };
    case UserTypes.SAVE_USER_PREFERENCES:
      let guidUserPreferences: string | null = null;
      let isViewCardUserPreferences: boolean = true; // Notation: Rule By Default is View Card true

      if (actionTypes.payload.preferences !== null) {
        if (actionTypes.payload.preferences.guid) {
          guidUserPreferences = actionTypes.payload.preferences.guid;
        }
        isViewCardUserPreferences = actionTypes.payload.preferences.isViewCard;
      }

      return {
        ...state,
        userPreference: {
          ...state.userPreference,
          preferences: {
            guid: guidUserPreferences,
            isViewCard: isViewCardUserPreferences
          },
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError
        }
      };
    case UserTypes.USER_OPEN_MODALUSER_CHANGEPASSWORD_ALERT:
      return {
        ...state,
        openModalUserChangePasswordAlert: actionTypes.payload.open,
        numberOfDaysToPasswordExpires: !isNullUndefined(
          actionTypes.payload.numberOfDaysToPasswordExpires
        )
          ? actionTypes.payload.numberOfDaysToPasswordExpires
          : state.numberOfDaysToPasswordExpires
      };
    default:
      return state;
  }
};

export default userReducer;
